import { injectable } from 'inversify';
import container from '@core/di';
import BaseStore from '@core/stores/base';
import { makeObservable, observable, runInAction } from 'mobx';
import { Clinician } from '@shared/models/clinician';
import ClinicianService from '@shared/services/clinician';

@injectable()
export default class ClinicianStore extends BaseStore<Clinician, ClinicianService> {
  static diToken = Symbol('clinician');

  notAssignedAssessmentCount = 0;
  totalNotApprovedEntitiesCount = 0;

  constructor() {
    super({ service: container.get<ClinicianService>(ClinicianService.diToken) });
    makeObservable<any>(this, {
      notAssignedAssessmentCount: observable,
      totalNotApprovedEntitiesCount: observable,
    });

    this.loading = {
      list: false,
      item: false,
    };
  }

  getFirstAssignedAssessments = async (page, pageSize) => {
    return await this.service.getFirstAssignedAssessments(page, pageSize);
  };

  getInitialPlanReview = async (page: number, pageSize: number) => {
    return await this.service.getInitialPlanReview(page, pageSize);
  };

  updateNotAssignedAssessmentsInfo = async () => {
    const response = await this.service.getAssignedAssessmentsInfo();
    runInAction(() => {
      this.notAssignedAssessmentCount = response.notAssignedAssessmentCount;
    });
  };

  getSubsiquentAssignedAssessments = async (page, pageSize) => {
    return await this.service.getSubsiquentAssignedAssessments(page, pageSize);
  };

  getAssessmentsTreatmentPlansInfo = async () => {
    const response = await this.service.getAssessmentsTreatmentPlansInfo();
    runInAction(() => {
      this.totalNotApprovedEntitiesCount = response.totalNotAprovedEntitiesCount;
    });

    return response;
  };
}
